(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
	/*
		Título del slide "Halloween": ajusta el tamaño para que cada línea quepa SIEMPRE en una sola fila.
		La tipografía de títulos del tema es la serif del sistema y su anchura cambia según el dispositivo
		(una serif de Android es más ancha que Times). El script mide el texto real y baja --hw-fit solo lo
		justo; nunca agranda. Sin JS, el CSS ya evita que la palabra se parta (nowrap).
	*/
	(() => {
		const SLIDE_SELECTOR = '.slideshow__slide--halloween';
		const SAFETY = 0.98;

		function fitSlide(slide) {
			const content = slide.querySelector('.slideshow__slide-content');
			const lines = slide.querySelectorAll('.hw-title__line');
			if (!content || lines.length === 0) return;

			slide.style.setProperty('--hw-fit', '1');

			const styles = getComputedStyle(content);
			const available = content.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
			if (available <= 0) return;

			let widest = 0;
			for (const line of lines) {
				widest = Math.max(widest, line.getBoundingClientRect().width);
			}
			if (widest <= available) return;

			const fit = Math.floor((available / widest) * SAFETY * 1000) / 1000;
			slide.style.setProperty('--hw-fit', String(fit));
		}

		function fitAll() {
			for (const slide of document.querySelectorAll(SLIDE_SELECTOR)) {
				fitSlide(slide);
			}
		}

		let frame = 0;
		function scheduleFit() {
			cancelAnimationFrame(frame);
			frame = requestAnimationFrame(fitAll);
		}

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', scheduleFit);
		} else {
			scheduleFit();
		}
		window.addEventListener('load', scheduleFit);
		window.addEventListener('resize', scheduleFit);
		document.addEventListener('shopify:section:load', scheduleFit);
		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(scheduleFit);
		}
	})();

  } catch(e) { console.error(e); }
})();
})();
